// Base pulsing placeholder block for loading states. Compose into
// page-specific skeletons (ProductCardSkeleton, BlogCardSkeleton, etc.)
// rather than using directly in pages, so the shape stays consistent.
const Skeleton = ({ className = '' }) => (
  <div className={`animate-pulse bg-charcoal/10 rounded-lg ${className}`} />
)

export default Skeleton
